import { WeekdayWeekHeatmapChart, WeekdayWeekHeatmapChartProps } from '../../../renderers/weekday-week-heatmap-chart/weekday-week-heatmap-chart.component';
import { IOTS_UPTIME_WEEKDAY_HEATMAP_CHART_DEFINITION } from './iots-uptime-weekday-heatmap-chart.definition';
import { IOTS_UPTIME_WEEKDAY_HEATMAP_CHART_MOCK_DATA } from './iots-uptime-weekday-heatmap-chart.mock';

export const IotsUptimeWeekdayHeatmapChart = (props: WeekdayWeekHeatmapChartProps) => <WeekdayWeekHeatmapChart {...props} />;

IotsUptimeWeekdayHeatmapChart.definition = IOTS_UPTIME_WEEKDAY_HEATMAP_CHART_DEFINITION;
IotsUptimeWeekdayHeatmapChart.mockData = IOTS_UPTIME_WEEKDAY_HEATMAP_CHART_MOCK_DATA;
